import React, { useEffect, useState } from "react";

import PageBar from "./PageBar";

const DetailsTitle = () => {
    const [titleDetails, setTitleDetails] = useState({});
    useEffect(() => {
        const titleData = JSON.parse(localStorage.getItem('detailsForTitle')).detailsForTitle;
        
        if(titleData.systemId === "26400046" || titleData.systemId === "26400056") {
            setTitleDetails({
                gush: titleData.gush,
                helka: titleData.helka,
                mezahe: titleData.mezahe,
                migrash: titleData.migrash,
                mispBait: titleData.mispBait,
                misparTik: titleData.misparTik,
                rehovCode: titleData.rehovCode,
                rehovName: titleData.rehovName,
                systemId: titleData.systemId
            });
        } else if (titleData.systemId === "26400001") {
            setTitleDetails({
                gush: titleData.gush,
                helka: titleData.helka,
                mispBait: titleData.mispBait,
                misparTik: titleData.misparTaba,
                rehovCode: titleData.rehovCode,
                rehovName: titleData.rehovName,
                systemId: titleData.systemId
            });
        }
        
    }, []);

    useEffect(() => {
      console.log('titleDetails', titleDetails);
    }, [titleDetails]);

    return (
        <PageBar>
            <div className="d-flex gap-4">
                {
                    titleDetails.rehovCode ? 
                        <span>
                            <span><b>כתובת: </b></span>
                            <span>{`${titleDetails.rehovName} ${titleDetails.mispBait ? `, ${titleDetails.mispBait}` : ""}`}</span>
                        </span>
                        :
                        ""
                } 
                
                {
                    titleDetails.gush ?
                        <span>
                            <span><b>גוש: </b></span>
                            <span>{`${titleDetails.gush}`}</span>
                        </span>
                        :
                        ""
                }               
                
                {
                    titleDetails.helka ?
                        <span>
                            <span><b>חלקה: </b></span>
                            <span>{`${titleDetails.helka}`}</span>
                        </span>
                        :
                        ""
                }

                {
                    titleDetails.systemId === "26400046" & titleDetails.mezahe ?
                        <span>
                            <span><b>תב''ע': </b></span>
                            <span>{`${titleDetails.mezahe}`}</span>
                        </span>
                        :
                        ""
                }

                {
                    titleDetails.systemId === "26400046" & titleDetails.migrash ?
                        <span>
                            <span><b>מגרש: </b></span>
                            <span>{`${titleDetails.migrash}`}</span>
                        </span>
                        :
                        ""
                }
            </div>
        </PageBar>
    )
}

export default DetailsTitle